module.exports = __webpack_public_path__ + "media/1.7e0d169d.wav";